// extracted by mini-css-extract-plugin
export var searchPopup = "styles-module--search-popup--06648";